import Four from "assets/svg/banner/four.svg";
import One from "assets/svg/banner/one.svg";
import Three from "assets/svg/banner/three.svg";
import Two from "assets/svg/banner/two.svg";
import React, { FC } from "react";

type Props = {
  countCourses: string;
  countStudents: string;
  banner: { url: string; alt: string };
  color: string;
};
const Banner: FC<Props> = ({ countCourses, countStudents, banner, color }) => {
  return (
    <div className="relative h-[388px] w-full">
      <img
        loading="lazy"
        src={banner?.url ?? "images/dadbanan-education.png"}
        alt={banner.alt ?? "dadBanan"}
        className="h-[388px] w-full object-cover"
        width="1920"
        height="388"
      />
      <div
        style={{
          background:
            color ??
            "linear-gradient(270deg, rgba(79, 155, 10, 0.8) 0%, rgba(120, 177, 66, 0.8) 100%)",
        }}
        className="absolute top-1/2 left-1/2 grid h-auto w-[80%] -translate-x-1/2 -translate-y-1/2 items-center gap-y-1  rounded-lg p-7 text-sm text-white md:h-48 md:grid-cols-2 lg:left-[10%] lg:w-[33rem] lg:translate-x-0"
      >
        <div className="flex items-center">
          <One className="ml-2 h-9 w-9" />
          {countStudents} دانش‌پذیر
        </div>
        <div className="flex items-center">
          <Two className="ml-2 h-9 w-9" />
          {countCourses} برگزاری دوره
        </div>
        <div className="flex items-center">
          <Three className="ml-2 h-9 w-9" />
          برگزاری آزمون‌های تخصصی
        </div>
        <div className="flex items-center">
          <Four className="ml-2 h-9 w-9" />
          اعطای مدرک پایان دوره
        </div>
      </div>
    </div>
  );
};

export default Banner;
